import type { FactFinderFacet } from '@ab-core/graphql/dist';
import type { SearchParameter } from '../../params';
import { changeSelectionState, fixedFiltersMock } from './fixedFiltersMock';
import { isFilterSet } from './saveState';

export { clearFixedFilter } from './saveState';

export const getFixedFilter = (isLoggedIn = false): SearchParameter['filter'] => {
    const fixedFilters: SearchParameter['filter'] = [];

    fixedFiltersMock.forEach((mockFixedFilter) => {
        if (mockFixedFilter.needUser && !isLoggedIn) {
            return;
        }

        if (isFilterSet(mockFixedFilter.urlFilter)) {
            fixedFilters.push(mockFixedFilter.urlFilter);
        }
    });

    return fixedFilters;
};

export const modifyFixedFilter = (factFinderFacets: Array<FactFinderFacet>, isLoggedIn = false) => {
    fixedFiltersMock.forEach((mockFixedFilter) => {
        if (mockFixedFilter.needUser && !isLoggedIn) {
            return;
        }

        const existingIndex = factFinderFacets.findIndex(
            (factFinderFacet) =>
                factFinderFacet.associatedFieldName === mockFixedFilter.factFinderFacet.associatedFieldName
        );

        if (existingIndex === -1) {
            factFinderFacets.splice(mockFixedFilter.defaultPositionInArray, 0, changeSelectionState(mockFixedFilter));
        }
    });
};
